// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600;700;800&family=Roboto:wght@300;400;500;700&family=Outfit:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sfo-navy: #1e3a5f;
  --sfo-blue: #3a8fb7;
  --sfo-light: #eaf4f8;
  --sfo-border: #d0e8f0;
  --sfo-bg: #f8fcfd;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Roboto', sans-serif;
  background-color: #ffffff;
  color: #1e293b;
  line-height: 1.6;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Barlow', sans-serif;
  font-weight: 700;
  line-height: 1.2;
}

.App {
  min-height: 100vh;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--sfo-bg);
}

::-webkit-scrollbar-thumb {
  background: var(--sfo-blue);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--sfo-navy);
}

/* ===== HARMONIZED BUTTON STYLES ===== */
.btn-primary {
  background: var(--sfo-navy);
  color: white;
  border-radius: 9999px;
  font-weight: 700;
  font-size: 0.875rem;
  padding: 0.75rem 1.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: none;
  cursor: pointer;
}

.btn-primary:hover {
  background: var(--sfo-blue);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(30, 58, 95, 0.25);
}

.btn-primary:active {
  transform: translateY(0) scale(0.98);
}

.btn-outline {
  background: transparent;
  color: var(--sfo-blue);
  border: 2px solid var(--sfo-blue);
  border-radius: 9999px;
  font-weight: 700;
  font-size: 0.875rem;
  padding: 0.625rem 1.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

.btn-outline:hover {
  background: var(--sfo-light);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(58, 143, 183, 0.15);
}

/* ===== HARMONIZED CARD STYLES ===== */
.card-hover {
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid var(--sfo-border);
  border-radius: 1rem;
}

.card-hover:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 40px rgba(30, 58, 95, 0.12);
  border-color: rgba(58, 143, 183, 0.4);
}

/* ===== LINK HOVER EFFECTS ===== */
a {
  transition: color 0.2s ease;
}

/* Gradient backgrounds */
.gradient-bg {
  background: linear-gradient(135deg, var(--sfo-light) 0%, #d5ecf5 100%);
}

.gradient-text {
  background: linear-gradient(135deg, var(--sfo-navy) 0%, var(--sfo-blue) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Glass morphism effect */
.glass-effect {
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.5);
}

/* Loading animation */
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Fade in animation */
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.animate-fadeInUp {
  animation: fadeInUp 0.5s ease-out;
}

/* Stagger children */
.stagger-children > *:nth-child(1) { animation-delay: 0ms; }
.stagger-children > *:nth-child(2) { animation-delay: 50ms; }
.stagger-children > *:nth-child(3) { animation-delay: 100ms; }
.stagger-children > *:nth-child(4) { animation-delay: 150ms; }
.stagger-children > *:nth-child(5) { animation-delay: 200ms; }
.stagger-children > *:nth-child(6) { animation-delay: 250ms; }
.stagger-children > *:nth-child(7) { animation-delay: 300ms; }
.stagger-children > *:nth-child(8) { animation-delay: 350ms; }
.stagger-children > *:nth-child(9) { animation-delay: 400ms; }

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,yCAAyC;AACzC;EACE,2BAA2B;EAC3B,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,uCAAuC;AACvC;EACE,kDAAkD;EAClD,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA,mCAAmC;AACnC;EACE,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,sEAAsE;AACxE;;AAEA;EACE,6EAA6E;EAC7E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA,sBAAsB;AACtB;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,iCAAiC;AACnC;;AAEA,qBAAqB;AACrB,qCAAqC,oBAAoB,EAAE;AAC3D,qCAAqC,qBAAqB,EAAE;AAC5D,qCAAqC,sBAAsB,EAAE;AAC7D,qCAAqC,sBAAsB,EAAE;AAC7D,qCAAqC,sBAAsB,EAAE;AAC7D,qCAAqC,sBAAsB,EAAE;AAC7D,qCAAqC,sBAAsB,EAAE;AAC7D,qCAAqC,sBAAsB,EAAE;AAC7D,qCAAqC,sBAAsB,EAAE","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600;700;800&family=Roboto:wght@300;400;500;700&family=Outfit:wght@300;400;500;600;700&display=swap');\n\n:root {\n  --sfo-navy: #1e3a5f;\n  --sfo-blue: #3a8fb7;\n  --sfo-light: #eaf4f8;\n  --sfo-border: #d0e8f0;\n  --sfo-bg: #f8fcfd;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Roboto', sans-serif;\n  background-color: #ffffff;\n  color: #1e293b;\n  line-height: 1.6;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: 'Barlow', sans-serif;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.App {\n  min-height: 100vh;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--sfo-bg);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--sfo-blue);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--sfo-navy);\n}\n\n/* ===== HARMONIZED BUTTON STYLES ===== */\n.btn-primary {\n  background: var(--sfo-navy);\n  color: white;\n  border-radius: 9999px;\n  font-weight: 700;\n  font-size: 0.875rem;\n  padding: 0.75rem 1.5rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  border: none;\n  cursor: pointer;\n}\n\n.btn-primary:hover {\n  background: var(--sfo-blue);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(30, 58, 95, 0.25);\n}\n\n.btn-primary:active {\n  transform: translateY(0) scale(0.98);\n}\n\n.btn-outline {\n  background: transparent;\n  color: var(--sfo-blue);\n  border: 2px solid var(--sfo-blue);\n  border-radius: 9999px;\n  font-weight: 700;\n  font-size: 0.875rem;\n  padding: 0.625rem 1.5rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: pointer;\n}\n\n.btn-outline:hover {\n  background: var(--sfo-light);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(58, 143, 183, 0.15);\n}\n\n/* ===== HARMONIZED CARD STYLES ===== */\n.card-hover {\n  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 1px solid var(--sfo-border);\n  border-radius: 1rem;\n}\n\n.card-hover:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 20px 40px rgba(30, 58, 95, 0.12);\n  border-color: rgba(58, 143, 183, 0.4);\n}\n\n/* ===== LINK HOVER EFFECTS ===== */\na {\n  transition: color 0.2s ease;\n}\n\n/* Gradient backgrounds */\n.gradient-bg {\n  background: linear-gradient(135deg, var(--sfo-light) 0%, #d5ecf5 100%);\n}\n\n.gradient-text {\n  background: linear-gradient(135deg, var(--sfo-navy) 0%, var(--sfo-blue) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Glass morphism effect */\n.glass-effect {\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n}\n\n/* Loading animation */\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n.animate-pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n/* Fade in animation */\n@keyframes fadeInUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.animate-fadeInUp {\n  animation: fadeInUp 0.5s ease-out;\n}\n\n/* Stagger children */\n.stagger-children > *:nth-child(1) { animation-delay: 0ms; }\n.stagger-children > *:nth-child(2) { animation-delay: 50ms; }\n.stagger-children > *:nth-child(3) { animation-delay: 100ms; }\n.stagger-children > *:nth-child(4) { animation-delay: 150ms; }\n.stagger-children > *:nth-child(5) { animation-delay: 200ms; }\n.stagger-children > *:nth-child(6) { animation-delay: 250ms; }\n.stagger-children > *:nth-child(7) { animation-delay: 300ms; }\n.stagger-children > *:nth-child(8) { animation-delay: 350ms; }\n.stagger-children > *:nth-child(9) { animation-delay: 400ms; }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
